import { render, staticRenderFns } from "./TestSinglePage.vue?vue&type=template&id=c8a8b336&scoped=true&"
import script from "./TestSinglePage.vue?vue&type=script&lang=js&"
export * from "./TestSinglePage.vue?vue&type=script&lang=js&"
import style0 from "./TestSinglePage.vue?vue&type=style&index=0&id=c8a8b336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a8b336",
  null
  
)

export default component.exports